// Phase 7 R1 — status pill for purchase orders + PO lines.
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const LABELS: Record<string, string> = {
  draft: 'Draft',
  submitted: 'Submitted',
  partially_received: 'Partial',
  received: 'Received',
  partially_returned: 'Partial Return',
  closed: 'Closed',
  canceled: 'Canceled',
  open: 'Open',
  returned: 'Returned',
};

const VARIANT: Record<string, 'default' | 'secondary' | 'destructive' | 'outline'> = {
  draft: 'outline',
  submitted: 'secondary',
  partially_received: 'secondary',
  received: 'default',
  partially_returned: 'secondary',
  closed: 'outline',
  canceled: 'destructive',
  open: 'outline',
  returned: 'outline',
};

interface Props {
  status: string;
  className?: string;
}

export function PurchaseOrderStatusBadge({ status, className }: Props) {
  return (
    <Badge variant={VARIANT[status] ?? 'outline'} className={cn('capitalize', className)}>
      {LABELS[status] ?? status}
    </Badge>
  );
}
